import { useTranslation } from "react-i18next";
import CookieConsent from "react-cookie-consent";
import "./CookieConsentBanner.css";

const CookieConsentBanner = ({ setConsent }) => {
  const { t } = useTranslation();

  const handleAccept = () => {
    setConsent(true);
    window.location.reload(); 
  };

  const handleDecline = () => {
    setConsent(false);
  };

  return (
    <div className="cookie-consent-overlay">
      <CookieConsent
        location="none"
        cookieName="vorpoint-cookie-consent"
        disableStyles
        containerClasses="cookie-consent-modal"
        contentClasses="cookie-consent-body"
        buttonClasses="cookie-btn-accept"
        declineButtonClasses="cookie-btn-decline"
        buttonText={t('cookie_consent.accept')}
        declineButtonText={t('cookie_consent.decline')}
        expires={150}
        enableDeclineButton
        onAccept={handleAccept}
        onDecline={handleDecline}
      >
        <div className="cookie-icon">🍪</div>
        <div className="cookie-text-container">
          <h3>{t('cookie_consent.title')}</h3>
          <p>{t('cookie_consent.message')}</p>
        </div>
      </CookieConsent>
    </div>
  );
};

export default CookieConsentBanner;
